<style>
    svg#event-phone-info {
        position: absolute;
        width: 90%;
        top: 20px;
        left: 20px;
    }

    .cls-1 {
        fill: none;
        stroke: #fff;
        stroke-miterlimit: 10;
        opacity: 0.35;
    }
    .cls-2,
    .cls-3 {
        fill: #fff;
    }
    .cls-2 {
        opacity: 0.4;
    }
</style>

<svg id="event-phone-info" viewBox="0 0 1080.91 36.59">
    <g data-name="Layer 2">
        <g id="phone_info" data-name="phone info">
            <path
                class="cls-1"
                d="M1007.8,26.6V8.19a6.51,6.51,0,0,1,.51-2.54,6.62,6.62,0,0,1,3.6-3.6,6.51,6.51,0,0,1,2.54-.51h51.14a6.51,6.51,0,0,1,2.54.51,6.7,6.7,0,0,1,2.16,1.44,6.6,6.6,0,0,1,1.44,2.16,6.5,6.5,0,0,1,.5,2.54V26.6a6.5,6.5,0,0,1-.5,2.54,6.6,6.6,0,0,1-1.44,2.16,6.7,6.7,0,0,1-2.16,1.44,6.51,6.51,0,0,1-2.54.51h-51.14a6.51,6.51,0,0,1-2.54-.51,6.62,6.62,0,0,1-3.6-3.6A6.51,6.51,0,0,1,1007.8,26.6Z"
            />
            <path class="cls-2" d="M1076.84,11.26V23.53a6.66,6.66,0,0,0,0-12.27" />
            <path
                class="cls-3"
                d="M1012.41,24.55V10.24a4,4,0,0,1,.31-1.57,4.22,4.22,0,0,1,.88-1.33,4.06,4.06,0,0,1,1.33-.88,4,4,0,0,1,1.57-.31h47a4,4,0,0,1,1.57.31,3.92,3.92,0,0,1,1.32.88,4.09,4.09,0,0,1,.89,1.33,4,4,0,0,1,.31,1.57V24.55a4,4,0,0,1-.31,1.57,4.09,4.09,0,0,1-.89,1.33,3.92,3.92,0,0,1-1.32.88,4,4,0,0,1-1.57.31h-47a4,4,0,0,1-1.57-.31,4.06,4.06,0,0,1-1.33-.88,4.22,4.22,0,0,1-.88-1.33A4,4,0,0,1,1012.41,24.55Z"
            />
            <path
                class="cls-3"
                d="M985.75,14.33a26.64,26.64,0,0,0-36.68,0,1,1,0,0,1-1.34,0l-3.56-3.59a1,1,0,0,1-.28-.71.94.94,0,0,1,.29-.69,33.57,33.57,0,0,1,46.45,0,1,1,0,0,1,.3.69,1,1,0,0,1-.29.71l-3.56,3.59a.94.94,0,0,1-1.33,0Zm-8.19,8.27a15.12,15.12,0,0,0-20.29,0,.94.94,0,0,1-1.33,0L952.38,19a1,1,0,0,1-.29-.71,1,1,0,0,1,.3-.7,22.06,22.06,0,0,1,30,0,1,1,0,0,1,0,1.41l-3.56,3.59a.94.94,0,0,1-.67.28A1,1,0,0,1,977.56,22.6ZM966.73,33.47l-6.16-6.21a1,1,0,0,1-.29-.71,1,1,0,0,1,.32-.7,10.56,10.56,0,0,1,13.62,0,1,1,0,0,1,.31.7.94.94,0,0,1-.29.71l-6.15,6.21a1,1,0,0,1-1.36,0Z"
            />
            <path
                class="cls-3"
                d="M879.45,33.76a3.07,3.07,0,0,1-3.06-3.07V24.56a3.07,3.07,0,0,1,3.06-3.08h3.07a3.07,3.07,0,0,1,3.07,3.08v6.13a3.07,3.07,0,0,1-3.07,3.07Zm14.32,0a3.08,3.08,0,0,1-3.07-3.07V18.42a3.07,3.07,0,0,1,3.07-3.07h3.07a3.06,3.06,0,0,1,3.07,3.07V30.69a3.07,3.07,0,0,1-3.07,3.07Zm14.32,0A3.08,3.08,0,0,1,905,30.69V11.26a3.07,3.07,0,0,1,3.07-3.07h3.07a3.07,3.07,0,0,1,3.07,3.07V30.69a3.08,3.08,0,0,1-3.07,3.07Zm14.32,0a3.07,3.07,0,0,1-3.07-3.07V4.1A3.06,3.06,0,0,1,922.41,1h3.07a3.07,3.07,0,0,1,3.07,3.07V30.69a3.08,3.08,0,0,1-3.07,3.07Z"
            />
            <path
                class="cls-3"
                d="M12.07,20.23a6.13,6.13,0,0,1-6.38-6.47,6.3,6.3,0,0,1,6.4-6.47,6.36,6.36,0,0,1,6.4,6.58A6.16,6.16,0,0,1,12.07,20.23Zm-.21,16.36C20.11,36.59,25,30.14,25,19.2,25,8.46,19.8,2.57,12,2.57,5,2.57,0,7.31,0,13.94A10.37,10.37,0,0,0,10.67,24.7a9,9,0,0,0,8.41-4.83h.38c-.07,7.62-2.79,12-7.53,12a5.64,5.64,0,0,1-5.71-4H.45C1.39,33.13,5.93,36.59,11.86,36.59Z"
            />
            <path
                class="cls-3"
                d="M34.27,31.31a3.49,3.49,0,1,0,0-7,3.49,3.49,0,1,0,0,7Zm0-16.49a3.42,3.42,0,0,0,3.6-3.49,3.41,3.41,0,0,0-3.6-3.48,3.42,3.42,0,0,0-3.6,3.48A3.43,3.43,0,0,0,34.27,14.82Z"
            />
            <path
                class="cls-3"
                d="M48.88,24.59C52.05,19.08,55.8,13.08,59.12,8h.32V24.93H48.88ZM59.35,35.8H64.9V29.58h4.38V24.79H64.9V3.38H56.72c-4.4,6.69-9,14.15-13.21,21.46v4.74H59.35Z"
            />
            <polygon
                class="cls-3"
                points="81.64 35.8 87.44 35.8 87.44 3.38 81.66 3.38 73.19 9.33 73.19 14.79 81.26 9.09 81.64 9.09 81.64 35.8"
            />
        </g>
    </g>
</svg>
